module.exports = __webpack_public_path__ + "media/images/image_checkin_info1-1ea1bf028ca7f9d3a9417fa889148871.jpg";